import useUpdateSearchParams from "./useUpdateSearchParams";

// Drop-in replacement for `useState` on a page's active tab (or similar
// single-choice view state) that keeps the value in the URL, so a reload or a
// shared link lands on the same tab instead of the page's first one.
//
//   const [tab, setTab] = useUrlTab(["Pending", "Approved"], "Pending");
//
// `allowed` guards against stale/hand-edited URLs (pass null to accept any
// value); define it at module level, not inline. The default is left out of
// the URL to keep it clean. Uses `replace` so switching tabs doesn't pile up
// browser-history entries.
const useUrlTab = (allowed, defaultValue, key = "tab") => {
  const [searchParams, updateParams] = useUpdateSearchParams();

  const resolve = (raw) =>
    raw != null && (!allowed || allowed.includes(raw)) ? raw : defaultValue;
  const value = resolve(searchParams.get(key));

  // Accepts a value or, like useState, an updater `prev => next`. `prev` is
  // the latest value (including a write not yet rendered), so back-to-back
  // updaters chain correctly.
  const setValue = (nextOrUpdater) => {
    updateParams(
      (current) => {
        const next =
          typeof nextOrUpdater === "function"
            ? nextOrUpdater(resolve(current.get(key)))
            : nextOrUpdater;
        return { [key]: next === defaultValue ? null : next };
      },
      { replace: true }
    );
  };

  return [value, setValue];
};

export default useUrlTab;
